import React, { useEffect, useState } from "react";
import Sidebar from "../../components/Sidebar";
import { Box } from "@mui/material";
import Topbar from "../../components/Appbar";
import theme from "../../theme/theme";
import { useNavigate } from "react-router-dom";
import Loader from "../../utils/Loader";
import LoaderHelper from "../../utils/Loader/LoaderHelper";
import { useAlert } from "../../context/AlertContext";
import AuthService from "../../api/AuthService";

const Dashboard = ({ children }) => {
  const navigate = useNavigate();
  const [activeTab, setActiveTab] = useState("dashboard");
  const [mobileViewOpen, setMobileViewOpen] = React.useState(false);
  const [employeeData,setEmployeeData] = useState();
  const [open, setOpen] = useState(false);
  const [isAuthorized, setIsAuthorized] = useState(false);
  const [companyInfo, setCompanyInfo] = useState(null);

  const {showAlert} = useAlert();
  const [loading,setLoading] = useState(false);
 
  useEffect(() => {
    const Token = localStorage.getItem("accessToken");
    if (!Token) {
      navigate("/");
      return;
    }
    // Hard email-verification gate: block the dashboard for unverified users so
    // there is no flash-of-dashboard before the API 403s come back.
    if (localStorage.getItem("isEmailVerified") === "false") {
      navigate("/verify-email");
      return;
    }
        const checkCompanyExists = async () => {
      const role = localStorage.getItem("role");
      if (role === "Admin") {
        try {
          const companyResult = await AuthService.getCompantList();
          if (!companyResult?.success || !companyResult?.data?.[0]?.companyName) {
            navigate("/companyInfo");
            return;
          }
          setIsAuthorized(true);
        } catch (error) {
          navigate("/companyInfo");
        }
      } else {
        setIsAuthorized(true);
      }
    };
    checkCompanyExists();
    fetchCompanyInfo();
  }, []);

  // Company name/logo for the top navbar. SuperAdmin/SubAdmin are platform
  // staff, not scoped to a single tenant company, so they never see this.
  // Confirmed via live network capture that the two roles need different
  // sources: Employee tokens only get company data back from GET /profile
  // (AuthService.getProfileView()), under the field `companyLogo` - GET
  // /company (getAccountSetting) and GET /company_details/:id
  // (handleCompanyDetails) are not authorized for that role. Admin keeps
  // using getAccountSetting() (`logo` field), which already matches what
  // the Company Info / Account Settings page saves.
  const fetchCompanyInfo = async () => {
    const role = localStorage.getItem("role");
    if (role === "SuperAdmin" || role === "SubAdmin") return;
    try {
      if (role === "Employee" || role === "employee") {
        const result = await AuthService.getProfileView();
        if (result?.success && result?.data) {
          setCompanyInfo({
            companyName: result?.data?.companyName,
            logo: result?.data?.companyLogo,
          });
        }
      } else {
        const result = await AuthService.getAccountSetting();
        if (result?.success && result?.data) {
          setCompanyInfo({
            companyName: result?.data?.companyName,
            logo: result?.data?.logo,
          });
        }
      }
    } catch (error) {
      // Non-critical for the navbar - fail silently and show no company info.
    }
  };

  // Permission is established once at login (see usecases/Login) and must remain the
  // source of truth for the session. This used to re-fetch getEmployeePermission and
  // overwrite localStorage["permission"] on every route change (this component wraps
  // every /dashboard/* route, so location.pathname changes on every navigation), which
  // silently replaced the correct login permission with a stale/mismatched value from
  // this endpoint. Removed — permission now only changes via an explicit
  // "permissionUpdated" dispatch, which nothing in the app currently triggers.

  const handleLogout = () =>{
    localStorage.clear();
    navigate("/");
  }
  const SearchEmployee = async(text) =>{
    setLoading(true);
    try {
      const result = await AuthService.getEmployeeList(text);
      if (result?.success) { 
        setEmployeeData(result?.data?.employees);
        setLoading(false);
        
      } else {
        setLoading(false);
      }
    } catch (error) {
      setLoading(false);
    }
  };
  const handleDownload = async(selectedType, fromDate, toDate, email, employee,data) => {
    setLoading(true)
    try {
      const result = await AuthService.download(selectedType, fromDate, toDate, email, employee, data,);
      if (result?.success === true) {
        setOpen(false);

        setLoading(false)
        showAlert(result?.message,"success");
      } else {
        setLoading(false)
        showAlert(result?.message,"error");
      }
    } catch (error) {
      setLoading(false)
      showAlert(error,"error");
    }
  };
  if (!isAuthorized) {
    return (
      <Box sx={{ display: "flex", justifyContent: "center", alignItems: "center", height: "100vh", backgroundColor: theme.palette.lightGray.main }}>
        <Loader ref={ref => LoaderHelper.setLoader(ref)} />
      </Box>
    );
  }

  return (
    <Box sx={{ display: "flex", height: "100vh" ,backgroundColor:theme.palette.lightGray.main}}>
      <Sidebar setActiveTab={setActiveTab} activeTab={activeTab}
        mobileViewOpen={mobileViewOpen} setMobileViewOpen={setMobileViewOpen}
      />

      <div style={{ display: "flex", flexDirection: "column", width: "100%" }}>
        <Topbar handleLogout={handleLogout}loading={loading} handleDownload={handleDownload} employeeData ={employeeData}handleEmployee={SearchEmployee} mobileViewOpen={mobileViewOpen} setMobileViewOpen={setMobileViewOpen} setOpen={setOpen} open={open}
          companyName={companyInfo?.companyName} companyLogo={companyInfo?.logo}
        />
        <div style={{ flex: 1, overflowY: "auto", }}>
          <Box sx={{ backgroundColor: theme.palette.lightGray.main ,height:"100vh"}}>
            <Loader ref={ref => LoaderHelper.setLoader(ref)} />
            {children}
          </Box>
        </div>
      </div>
    </Box>
  )

}

export default Dashboard;
